/*
 * Public API Surface of ngx-form-validator
 */

// export * from './lib/ngx-form-validator.service';
export * from './lib/ngx-form-validator.component';
export * from './lib/ngx-form-validator.module';
export * from './lib/Directive/validator-directive';
export * from './lib/Directive/label-service'
